import { useMemo } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Box, Paper, Typography, Button, Alert } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { alpha } from '@mui/material/styles';
import { COLORS } from '../../theme/themeConstants';

const PaymentFeaturedHyperPayCancel = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const subscriptionId = useMemo(() => searchParams.get('subscriptionId') || '', [searchParams]);
  const checkoutId = useMemo(() => searchParams.get('checkoutId') || searchParams.get('id') || '', [searchParams]);
  const merchantId = useMemo(() => searchParams.get('merchantId') || '', [searchParams]);

  return (
    <Box sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      p: 2,
      background: 'linear-gradient(135deg, #f5f7fa 0%, #e8eaed 100%)'
    }}>
      <Paper sx={{
        p: 4,
        maxWidth: 560,
        width: '100%',
        border: '1px solid #e8eaed',
        borderRadius: 3,
        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.08)',
        textAlign: 'center'
      }}>
        {/* Header */}
        <Typography variant="h5" sx={{
          fontWeight: 700,
          mb: 1,
          color: 'text.primary'
        }}>
          Payment Cancelled
        </Typography>
        
        {subscriptionId && (
          <Typography variant="body2" sx={{
            color: 'text.secondary',
            mb: 3
          }}>
            Subscription: {subscriptionId}
          </Typography>
        )}

        {/* Cancel Icon */}
        <Box sx={{
          width: 80,
          height: 80,
          borderRadius: '50%',
          background: alpha('#f59e0b', 0.1),
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 24px'
        }}>
          <CancelIcon sx={{
            fontSize: 48,
            color: '#f59e0b'
          }} />
        </Box>

        {/* Message */}
        <Alert severity="warning" sx={{ mb: 3, textAlign: 'left' }}>
          Your HyperPay payment was cancelled. No charges have been made to your account.
        </Alert>
        
        <Typography variant="body1" sx={{ mb: 3, color: 'text.secondary' }}>
          You can try again or contact our support team if you need assistance.
        </Typography>

        {/* Action Buttons */}
        <Box sx={{
          display: 'flex',
          gap: 2,
          mt: 4,
          flexDirection: { xs: 'column', sm: 'row' }
        }}>
          <Button
            variant="contained"
            onClick={() => navigate('/layout/makeyourRestaurant')}
            fullWidth
            sx={{
              background: COLORS.primary.main,
              '&:hover': {
                background: alpha(COLORS.primary.main, 0.9)
              }
            }}
          >
            Try Again
          </Button>
          <Button
            variant="outlined"
            onClick={() => navigate('/layout/dashboard')}
            fullWidth
            sx={{
              borderColor: COLORS.primary.main,
              color: COLORS.primary.main,
              '&:hover': {
                borderColor: COLORS.primary.main,
                background: alpha(COLORS.primary.main, 0.05)
              }
            }}
          >
            Go to Dashboard
          </Button>
        </Box>

        {/* Transaction Details */}
        {checkoutId && (
          <Typography variant="caption" sx={{
            display: 'block',
            mt: 3,
            color: 'text.secondary',
            opacity: 0.7
          }}>
            Checkout ID: {checkoutId}
          </Typography>
        )}
        {merchantId && (
          <Typography variant="caption" sx={{
            display: 'block',
            mt: 1,
            color: 'text.secondary',
            opacity: 0.7
          }}>
            Merchant ID: {merchantId}
          </Typography>
        )}
      </Paper>
    </Box>
  );
};

export default PaymentFeaturedHyperPayCancel;
